const currentNav = document.querySelector('.current a');
const currentNavToggle = document.querySelector('.current .mobile-nav-toggle');
const navContainer = document.querySelector('.user-profile-nav');
function toggleAccountNav() {
	currentNav && currentNav.addEventListener('click', (e) => {
		e.preventDefault();
	});
	currentNavToggle && currentNavToggle.addEventListener('click', () => {
		currentNavToggle.classList.toggle('active');
		navContainer.classList.toggle('show-nav');
	});
}

toggleAccountNav();